export const getHasAddedProductByBarcode = (store: Store) => store.barcodeScanner.hasAddedProductByBarcode;
export const getIsAddingProductByBarcode = (store: Store) => store.barcodeScanner.isAddingProductByBarcode;
export const getIsProductByBarcodeSoldOut = (store: Store) => store.barcodeScanner.isProductByBarcodeSoldOut;
export const getHasAddingByBarcodeFailed = (store: Store) => store.barcodeScanner.hasAddingByBarcodeFailed;
export const getShouldAddToSelection = (store: Store) => store.barcodeScanner.shouldAddToSelection;
export const getScannedBarcode = (store: Store) => store.barcodeScanner.scannedBarcode;
